import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { buscarTiposAgendamentosApi } from '../api/BuscarTiposAgendamentosApi';
import { hasGestorSelecionado } from '../api/shared';
import type { BuscarTiposAgendamentosResponse } from '../types';

export function useBuscarTiposAgendamentos(
  options?: Omit<UseQueryOptions<BuscarTiposAgendamentosResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();

  const query = useQuery<BuscarTiposAgendamentosResponse, Error>({
    queryKey: ['relatorios', 'tipos-agendamento'],
    queryFn: buscarTiposAgendamentosApi,
    ...options,
    enabled: (options?.enabled ?? true) && hasGestorSelecionado(),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar tipos de agendamento',
      description: 'Não foi possível carregar os tipos de agendamento.',
    });
  }, [query.error, toast]);

  return query;
}
